(function() {
  function initCollectionSection(section) {
    const characterFilter = section.querySelector('.js-filter-character');
    const rarityFilter = section.querySelector('.js-filter-rarity');
    const cards = section.querySelectorAll('.js-collection-card');
    const grid = section.querySelector('.js-cards-grid');

    if (!cards.length) return;

    // Helper: update a single card's active rarity view
    function updateCardRarity(card, targetRarity) {
      card.setAttribute('data-active-rarity', targetRarity);

      // Toggle image visibility
      const images = card.querySelectorAll('.js-rarity-image');
      images.forEach(img => {
        if (img.getAttribute('data-rarity') === targetRarity) {
          img.classList.remove('hidden');
        } else {
          img.classList.add('hidden');
        }
      });

      // Update desktop tabs active state
      const tabs = card.querySelectorAll('.js-rarity-tab');
      tabs.forEach(tab => {
        if (tab.getAttribute('data-rarity') === targetRarity) {
          tab.classList.add('active');
        } else {
          tab.classList.remove('active');
        }
      });

      // Update mobile select option value
      const mobSelect = card.querySelector('.js-rarity-select');
      if (mobSelect && mobSelect.value !== targetRarity) {
        mobSelect.value = targetRarity;
      }
    }

    // Card-specific Rarity Change Listeners (Desktop Tabs & Mobile Dropdown)
    cards.forEach(card => {
      const tabs = card.querySelectorAll('.js-rarity-tab');
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const rarity = tab.getAttribute('data-rarity');
          updateCardRarity(card, rarity);
        });
      });

      const mobSelect = card.querySelector('.js-rarity-select');
      if (mobSelect) {
        mobSelect.addEventListener('change', (e) => {
          updateCardRarity(card, e.target.value);
        });
      }
    });

    // Character Filter Listener
    if (characterFilter) {
      characterFilter.addEventListener('change', (e) => {
        // Clean up any existing cloned cards first
        section.querySelectorAll('.js-cloned-card').forEach(c => c.remove());

        const selectedChar = e.target.value;
        if (selectedChar === 'all') {
          if (rarityFilter) {
            rarityFilter.disabled = false;
            // Sync cards back to the selected global rarity
            cards.forEach(card => {
              updateCardRarity(card, rarityFilter.value);
              card.style.display = '';
            });
          } else {
            cards.forEach(card => card.style.display = '');
          }
        } else {
          if (rarityFilter) {
            rarityFilter.disabled = true;
          }
          cards.forEach(card => {
            card.style.display = 'none';
          });

          const targetCard = Array.from(cards).find(c => c.getAttribute('data-character') === selectedChar);
          if (targetCard && grid) {
            ['common', 'rare', 'super-rare'].forEach(rarity => {
              const clone = targetCard.cloneNode(true);
              clone.classList.add('js-cloned-card');
              clone.style.display = '';
              updateCardRarity(clone, rarity);
              
              // Hide individual rarity selectors/tabs on the clones
              const tabs = clone.querySelector('.complete-collection__tabs');
              if (tabs) tabs.style.display = 'none';
              const mobSelectWrapper = clone.querySelector('.complete-collection__mobile-select-wrapper');
              if (mobSelectWrapper) mobSelectWrapper.style.display = 'none';
              
              grid.appendChild(clone);
            });
          }
        }
      });
    }

    // Global Rarity Filter Listener
    if (rarityFilter) {
      rarityFilter.addEventListener('change', (e) => {
        const selectedRarity = e.target.value;
        cards.forEach(card => {
          updateCardRarity(card, selectedRarity);
        });
      });
    }
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.complete-collection').forEach(initCollectionSection);
  });

  // Theme editor reload handling
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.complete-collection');
    if (section) {
      initCollectionSection(section);
    }
  });
})();
